import { AppData, Colors, Img, Lightning } from "@lightningjs/sdk";
import { Theme } from "./info-ui";
import { AppSetup } from "../lib/app-setup";

export interface TextItemTemplateSpec extends Lightning.Component.TemplateSpec {
  Background: object;
  Label: object;
}

export default class TextItem
  extends Lightning.Component<TextItemTemplateSpec>
  implements Lightning.Component<TextItemTemplateSpec>
{
  Background = this.getByRef("Background")!;
  Label = this.getByRef("Label")!;
  _item: any;
  _theme: Theme = {};
  __ref = 'TextItem'
  static override _template(): Lightning.Component.Template<TextItemTemplateSpec> {
    return {
      w: (w) => w,
      h: (h) => h,
      collision:true,
      Background: {
        w: (w) => w,
        h: (h) => h,
        rect: true,
        color: textItemConfig.itemBGColor,
        //shader: { type: Lightning.shaders.RoundedRectangle, radius: 8 },
      },
      Label: {
        //x: (w) => w / 2,
        x: (w) => 10,
        y: (h) => h / 2,
        color: textItemConfig.itemLabelColor,
        mountX: 0,
        mountY: 0.4,
        text: {
          text: this.bindProp("label"),
          fontSize: textItemConfig.itemFontSize,
          textOverflow: "ellipsis",
          wordWrap:false,
          //textAlign:"left",
          //wordWrapWidth: this.bindProp("w"),
        },
      },
      // fontFace: 'Fresca',
    };
  }
  set item(obj: any) {
    this._item = obj;
    this._update();
  }

  override _init() {
    this.parent.collision = true;
    this.parent.parent.collision = true;
    this.patch({
      Label: { text: { wordWrapWidth: this.w-20 } },
    });

    const { appState } = AppData as AppSetup
    const app = appState?.getApp();
    this._theme = (app?.themesObj as Theme) || {};
    const appApiConfig = appState?.getAppApiConfig()
    this._theme.gridfocuscolor= `0xff${appApiConfig?.appLayoutConfig?.gridfocuscolor}` || '0xffffffff'
  }

  _update() {
    if (!this.active || !this._item) {
      return;
    }
    const { label = "X" } = this._item || {};
    this.patch({
      Label: { text: { text: label } },
    });
  }

  override _firstActive() {
    this._update();
  }

  override _focus() {
    const { platform } = AppData as AppSetup
    platform?.textToSpeach(this._item.label)

    this.patch({
      Background: {
        smooth: {
          // color: textItemConfig.itemBGColorFocus /*Colors("#C22843").get()*/,
          color:parseInt(this._theme.gridfocuscolor)
        },
      },
      Label: {
        smooth: {
          color: textItemConfig.itemLabelColorFocus /*Colors("white").get()*/,
        },
      },
    });
  }

  override _unfocus() {
    this.patch({
      Background: {
        smooth: {
          color: textItemConfig.itemBGColor /*Colors("#777777").get()*/,
        },
      },
      Label: {
        smooth: {
          color: textItemConfig.itemLabelColor /*Colors("white").get()*/,
        },
      },
    });
  }

  _handleHover(target) {
   // console.log('SuggestionList _handleHover:', target)
    this.collectionWrapper.setIndex(target.itemIndex, {immediate:true});
    this.fireAncestors('$setStateHover', 'SuggestionList')    
  }

  _handleClick(target) {
   // console.log('SuggestionList _handleClick:', target)
    this.fireAncestors('$SuggestionListhandleEnter')
  }

}



const textItemConfig = {
  //itemBGColor: Colors("#777777").get(),
  //itemBGColorFocus: Colors("#C22843").get(),
  itemBGColor: 0x00ffff00,//Colors("#38385e").get(),
  itemBGColorFocus: Colors("#ff0000").get(),

  itemLabelColor: Colors("white").get(),
  itemLabelColorFocus: Colors("white").get(),

  itemFontSize: 32,
};
